import React, { useReducer } from "react"
import processSchema from "./StateSchema"
import Context from "./Context"

// For å legge til felter i GlobalState legg de inn i InitialFieldState (skjemafelter) og GlobalStateSchema
const InitialFieldState = {
  internregistrering: {
    erPåVegneAv: undefined,
    navn: undefined,
    mottattVia: undefined,
  },
  erAnonym: undefined,
  erAnsatt: undefined,
  personalia: {
    navn: undefined,
    landkode: "47",
    landIso: "NO",
    nasjonaltTelefonnummer: "",
    telefonnummer: "",
    epost: undefined,
  },
  rolle: undefined,
  tema: undefined,
  hvaGjelderDet: undefined,
  virksomhet: {
    navn: "",
    organisasjonsnummer: "",
    organisasjonsformKode: "",
    organisasjonsformNavn: "",
    adresse: "",
    postnummer: "",
    poststed: "",
    annenInformasjon: "",
  },
  sted: {
    adresse: "",
    postnummer: "",
    poststed: "",
    annenInformasjon: "",
  },
  posisjon: {
    latitude: 0,
    longitude: 0,
  },
}

const GlobalStateSchemaDefinition = {
  klient: {
    brukerIp: undefined,
    erIntern: undefined,
  },
  loading: false,
  language: undefined,
  bruker: {
    id: undefined,
    erInnlogget: false,
  },
  erSkjemaGjennomført: false,
  tilgangDialog: false,
  idNummerDialog: undefined,
  fields: {
    ...InitialFieldState,
    internregistrering: { ...InitialFieldState.internregistrering },
    personalia: { ...InitialFieldState.personalia },
    virksomhet: { ...InitialFieldState.virksomhet },
    sted: { ...InitialFieldState.sted },
    posisjon: { ...InitialFieldState.posisjon },
    // NB! evt nye objekter i InitialFieldState må spres her
  },
  queryParams: undefined,
}

const GlobalInitialState = processSchema(GlobalStateSchemaDefinition)
const GlobalContext = new Context(GlobalStateSchemaDefinition)
// After processSchema transforms the schema, all properties become SchemaElements
const GlobalStateSchema = GlobalStateSchemaDefinition as any

interface GlobalContextProviderProps {
  children?: React.ReactNode
}

const GlobalContextProvider: React.FC<GlobalContextProviderProps> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(
    GlobalContext.reducer,
    GlobalInitialState
  )
  return (
    <GlobalContext.stateContext.Provider value={state}>
      <GlobalContext.dispatchContext.Provider value={dispatch}>
        {children}
      </GlobalContext.dispatchContext.Provider>
    </GlobalContext.stateContext.Provider>
  )
}

const StateValues = {
  Ja: "1",
  Nei: "0",
}

export default GlobalContext
export {
  GlobalContextProvider,
  GlobalStateSchema,
  StateValues,
  InitialFieldState,
}
